'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.nonStandardLanguageDomains = exports.supportedLanguages = exports.nonStandardWixLanguages = exports.nonStandardLanguages = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Maps non-standard Wix language IDs to standard langauge IDs
var nonStandardLanguages = exports.nonStandardLanguages = {
    'iw': 'he', // Hebrew
    'no': 'nb' // Norwegian (Bokmål)
};

var nonStandardWixLanguages = exports.nonStandardWixLanguages = _lodash2.default.invert(nonStandardLanguages);

// Wix officially-supported languages (as standard langauge IDs)
var supportedLanguages = exports.supportedLanguages = ['cs', // Czech
'da', // Danish
'de', // German
'en', // English
'es', // Spanish
'fr', // French
'hi', // Hindi
'it', // Italian
'ja', // Japanese
'ko', // Korean
'nb', // Norwegian
'nl', // Dutch
'pl', // Polish
'pt', // Portuguese
'ru', // Russian
'sv', // Swedish
'tr', // Turkish
'th', // Thai
'uk', // Ukrainian
'zh'];

// Maps languages with non-standard Wix subdomains to their subdomains
var nonStandardLanguageDomains = exports.nonStandardLanguageDomains = {
    'en': 'www', // English
    'nb': 'no' // Norwegian (Bokmål)
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-locales/dist/Wix.js
// module id = 860
// module chunks = 0